import {
  RenderedSectionResults,
  GroupAndRenderSegmentsArgs,
  HitsGroup,
} from '../types'
import getRenderForSegment from './get-render-for-segment'
import groupSegmentsByHeadings from './group-segments-by-heading'

import { makeHeadingInfo } from './headings'

export function groupSegments(args: GroupAndRenderSegmentsArgs): HitsGroup[] {
  const { headingsToDisplay, getHeadingForSegment } = makeHeadingInfo(
    args.context.centre
  )
  return groupSegmentsByHeadings({
    ...args,
    headingsToDisplay,
    getHeadingForSegment,
  })
}

export default function groupAndRenderSegments(
  args: GroupAndRenderSegmentsArgs
): RenderedSectionResults[] {
  const grouped = groupSegments(args)
  return grouped.map(({ heading, hits }) => ({
    heading,
    hits: hits.map(({ segment, hit, context, onResultClick }, index) =>
      getRenderForSegment(segment)({
        hit,
        context,
        onResultClick,
        index,
      } as any)
    ),
  }))
}
